import { useSearchParams } from "next/navigation";

import { END_OF_YEAR_CHECKLIST_ENTRY_POINT } from "@/common/constants/amplitude";

const END_OF_YEAR_CHECKLIST_SEARCH_PARAM = "endOfYearChecklist";

export const END_OF_YEAR_CHECKLIST_SEARCH_PARAMS = { [END_OF_YEAR_CHECKLIST_SEARCH_PARAM]: "true" };

export const useEndOfYearChecklistEntryPoint = (): typeof END_OF_YEAR_CHECKLIST_ENTRY_POINT | null => {
  const searchParams = useSearchParams();
  return searchParams.get(END_OF_YEAR_CHECKLIST_SEARCH_PARAM) === "true" ? END_OF_YEAR_CHECKLIST_ENTRY_POINT : null;
};
